import { render } from "./App.vue?vue&type=template&id=304bd1bc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Mapua\\Mapua Submissions\\IT135-8L\\PROJECT\\WEB APP\\IT135-8L_TFYO\\tfyo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__